module.exports = __webpack_public_path__ + "img/20191213165232003.4b94114e.jpg";